import acYear from '@/api/academic-year'
import scoreGenerate from '@/api/generate-total-score'
import acp from '@/api/main-program'
import scoring from '@/api/student-scoring-entry'
import SubProgram from '@/api/sub-program'
import term from '@/api/term-semester'

import { baseMutations, baseState } from '@/store/mixins'

export const state = {
  ...baseState,
  scoring_cycle_id: null,
  cycle_value: null,
  ac_year_id: null,
  branch_id: [],
  acp_id: null,
  ac_term_id: null,
  class_id: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_SCORING_CYCLE_ID(state, id) {
    state.scoring_cycle_id = id
    state.cycle_value = null
  },
  SET_CYCLE_VALUE(state, value) {
    state.cycle_value = value
  },
  SET_BRANCH_LIST(state, branch_id) {
    state.branch_id = branch_id
  },
  SET_AC_YEAR_ID(state, ac_year_id) {
    state.ac_year_id = ac_year_id
  },
  SET_MAIN_PROGRAM(state, acp_id) {
    state.acp_id = acp_id
  },
  SET_AC_TERM_ID(state, ac_term_id) {
    state.ac_term_id = ac_term_id
    state.cycle_value = null
  },  
  SET_CLASS_ID(state, class_id) {
    state.class_id = class_id || []
    state.pagination.page = 1
  },
  RESET_FILTER(state) {
    state.scoring_cycle_id = null
    state.cycle_value = null
    state.ac_year_id = null
    state.branch_id = []
    state.acp_id = null
    state.ac_term_id = null
    state.class_id = []
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        scoring_cycle_id: context.state.scoring_cycle_id,
        cycle_value: context.state.cycle_value,
        branch_id: context.state.branch_id,
        ac_year_id: context.state.ac_year_id,
        acp_id: context.state.acp_id,
        ac_term_id: context.state.ac_term_id,
        class_id: context.state.class_id,
      },
      attrubutes
    )
    return scoreGenerate.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return scoreGenerate.store(data)
  },

  releaseScore(context, scoring_total_id_list) {
    return scoreGenerate.releaseScore({ scoring_total_id_list })
  },  
  releaseCheckError(context, scoring_total_id_list) {
    return scoreGenerate.releaseCheckError({ scoring_total_id_list })
  },
  getAcYear(context) {
    return acYear.get({
      params: {
        fields: {
          academic_years: 'ac_year_id,ac_year,ac_status_id'
        },
        filter: {
          ac_status_id: [1, 2]
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getMainProgram(context) {
    return acp.get({
      params: {
        fields: {
          academic_program_mains: 'acp_id,acp_name_foreign'
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getSubProgram(context, { acp_id }) {
    return SubProgram.get({
      params: {
        fields: {
          academic_program_subs: 'acps_id,acps_name_foreign'
        },
        filter: {
          acp_id: acp_id
        },
        page: -1
      },
      headers: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getTermByMainProgram(context, { ac_year_id, acp_id }) {
    return term.get({
      params: {
        fields: {
          academic_terms: 'ac_term_id,term_name,ac_status_id'
        },
        filter: {
          ac_year_id: ac_year_id,
          by_main_program: acp_id,
          // ac_status_id: 1  no filter  status
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  getStudentScoringEntry(context, { ac_year_id, acp_id, ac_term_id }) {
    return scoring.get({
      params: {
        filter: {
          acp_id: acp_id,
          ac_year_id: ac_year_id,
          ac_term_id: ac_term_id,
          exclude_null: true
        },
        page: -1
      },
      header: {
        'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
      }
    })
  },
  formViewModel(context, Options = {}) {
    return scoreGenerate.formViewModel({ params: Options })
  },
  generateTotalAvg(context, data) {
    return scoreGenerate.generateTotalAvg(data)
  }
}
